<template>
    <div class="header" v-bind:style="headerTopStyle" style="z-index: 999">
        <div class="headerTop">
            <img src="../assets/logow.png" style="height: 30px;background:#2596d5 "><img src="../assets/title.png"
                                                                                         class="header-banner"></div>
        <div class="headerFixed">
            <!--            <div class="header-number"><img src="../assets/logow.png" style="width: 60%"></div>-->
            <div class="header-number">
                <div class="header-number-count">
                    <div v-show="counts&&counts.definite>0">{{counts.definite}}</div>
                    <div v-show="counts&&counts.definite<=0">未通报</div>
                </div>
                <div class="header-number-title">累计确诊</div>
            </div>
            <div class="header-number">
                <div class="header-number-count">
                    <div v-show="counts&&counts.suspect>0">{{counts.suspect}}</div>
                    <div v-show="counts&&counts.suspect<=0">未通报</div>
                </div>
                <div class="header-number-title">现有疑似</div>
            </div>
            <div class="header-number">
                <div class="header-number-count">
                    <div v-show="counts&&counts.death>0">{{counts.death}}</div>
                    <div v-show="counts&&counts.death<=0">未通报</div>
                </div>
                <div class="header-number-title">累计死亡</div>
            </div>
            <div class="header-number">
                <div class="header-number-count">
                    <div v-show="counts&&counts.recovery>0">{{counts.recovery}}</div>
                    <div v-show="counts&&counts.recovery<=0">未通报</div>
                </div>
                <div class="header-number-title">累计治愈</div>
            </div>
        </div>

        <div class="timeline-range">
            <div class="timeline-range-item" style="width: 37px">热度</div>
            <div class="timeline-range-item">
                <div class="rect-text one">0-5000</div>
            </div>
            <div class="timeline-range-item">
                <div class="rect-text two">5001-50000</div>
            </div>
            <div class="timeline-range-item">
                <div class="rect-text three">50001-200000</div>
            </div>
            <div class="timeline-range-item">
                <div class="rect-text four">200001-500000</div>
            </div>
            <div class="timeline-range-item">
                <div class="rect-text five">>500000</div>
            </div>
        </div>
        <div class="timeline-legend">
            <div class="timeline-legend-item" v-bind:class="[legends.red?'':'legend-disable']"
                 @click="legendClick('red')">
                <div class="point red"></div>
                <div class="point-text">疫情进展</div>
            </div>
            <div class="timeline-legend-item" v-bind:class="[legends.green?'':'legend-disable']"
                 @click="legendClick('green')">
                <div class="point green"></div>
                <div class="point-text">国家举措</div>
            </div>
            <div class="timeline-legend-item" v-bind:class="[legends.blue?'':'legend-disable']"
                 @click="legendClick('blue')">
                <div class="point blue"></div>
                <div class="point-text">湖北举措</div>
            </div>
            <div class="timeline-legend-item" v-bind:class="[legends.purple?'':'legend-disable']"
                 @click="legendClick('purple')">
                <div class="point purple"></div>
                <div class="point-text">非鄂举措</div>
            </div>
            <div class="timeline-legend-item" v-bind:class="[legends.yellow?'':'legend-disable']"
                 @click="legendClick('yellow')">
                <div class="point yellow"></div>
                <div class="point-text">国际举措</div>
            </div>
        </div>
        <div class="timeline-title">
            <div class="timeline-title-left">疫情进展</div>
            <div class="timeline-title-middle">热度变化</div>
            <div class="timeline-title-right">各方举措</div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Header',
        props: {
            countsMap: Object,
            legends: Object

        },
        data() {
            return {
                headerTop: 0,
                headerTopStyle: {
                    top: '0px'
                },
                counts: {},
                scrollTop: window.scrollTop
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll, true)
        },
        methods: {
            handleScroll() {
                this.headerTop = document.documentElement.scrollTop||document.body.scrollTop;
                // alert(this.headerTop)
                if (this.headerTop >= 0 && this.headerTop < 85.5) {
                    this.headerTopStyle.top = (-this.headerTop) + 'px';
                }
                if (this.headerTop > 85.5) {
                    this.headerTopStyle.top = '-85.5px';
                }
                // console.log(document.elementFromPoint(100, 200).innerHTML, this.countsMap[document.elementFromPoint(100, 200).innerHTML])
                if (this.countsMap[document.elementFromPoint(100, 200).innerHTML]) {
                    this.counts = this.countsMap[document.elementFromPoint(100, 200).innerHTML]
                }
            },
            legendClick: function (type) {
                this.legends[type] = !this.legends[type]
                this.$emit('update:', this.legends)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header {
        /*background: #2596d5;*/
        position: fixed;
        width: 100vw;

    }

    .header-banner {
        width: 100%;
    }

    .headerFixed {
        height: 60px;
        background: #2596d5;
        display: flex;

    }

    .header-number {
        width: 25%;
        color: white;
        font-weight: bold;
        display: flex;
        justify-content: center;
        flex-flow: column;
        flex-direction: column;
        align-items: center;
    }

    .header-number-count {
        font-size: 20px;
    }

    .point {
        width: 10px;
        height: 10px;
        /*border-radius:5px*/
    }


    .timeline-legend {
        padding: 5px 5px;
        display: flex;
        background: white;
    }

    .timeline-legend-item {
        display: flex;
        align-items: center;
        width: 20vw;
    }

    .point-text {
        margin-left: 5px;
    }

    .timeline-range {
        padding: 5px 5px;
        background: white;
        display: flex;
        justify-content: space-around
    }

    .timeline-range-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15vw;
    }


    .rect-text {
        font-size: 12px;
        width: 15vw;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: whitesmoke;

        font-weight: bold;

    }

    .timeline-title {
        display: flex;
        justify-content: space-around;
        background-color: white;
        height: 35px;
    }

    .timeline-title-left {
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: white;
        background: #961620;
    }

    .timeline-title-middle {
        text-align: center;
        line-height: 30px;
        width: 100px;
        height: 30px;
    }

    .timeline-title-right {
        width: 100px;
        height: 30px;
        color: white;
        text-align: center;
        line-height: 30px;
        background: #999999;
    }

    .legend-disable {
        opacity: 0.5;
    }

    .headerTop {
        background: #2596d5;
        padding-top: 5px;
    }
</style>
